import APIClient from '@/shared/http/clients/api'

const resourceName = 'poupanca'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=dataMovimento,desc&`, config)

/**
 * @name ContaPoupancaRepository
 * @description Saldo médio captação
 * @type { Respository }
 */
const ContaPoupancaRepository = {
  Search
}

export default ContaPoupancaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/contaPoupanca.js